import { IconProps } from "@/common/contracts/icon.contracts";

export const SearchImage = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6160_13553)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 19.6026V21.4026H19.65C20.001 21.4026 20.316 21.2586 20.586 20.9886C20.856 20.7186 21 20.4036 21 20.0526V16.9026H19.2V19.6026H16.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.35 21.4026H7.5V19.6026H4.8V16.9026H3V20.0526C3 20.4036 3.144 20.7186 3.414 20.9886C3.684 21.2586 3.999 21.4026 4.35 21.4026Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.65 3.40259H16.5V5.20259H19.2V7.90259H21V4.75259C21 4.40159 20.856 4.08659 20.586 3.81659C20.316 3.54659 20.001 3.40259 19.65 3.40259Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 5.20259V3.40259H4.35C3.999 3.40259 3.684 3.54659 3.414 3.81659C3.144 4.08659 3 4.40159 3 4.75259V7.90259H4.8V5.20259H7.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.484 13.5456C14.898 12.8886 15.132 12.1056 15.132 11.2686C15.132 8.90156 13.233 7.00256 10.866 7.00256C8.49898 7.00256 6.59998 8.90156 6.59998 11.2686C6.59998 13.6356 8.49898 15.5346 10.866 15.5346C11.694 15.5346 12.468 15.3006 13.125 14.8956L16.086 17.8026L17.4 16.4886L14.484 13.5456ZM12.54 12.9426C12.099 13.3926 11.496 13.6356 10.866 13.6356C10.236 13.6356 9.63298 13.3926 9.19198 12.9426C8.74198 12.5016 8.49898 11.8986 8.49898 11.2686C8.49898 10.6386 8.74198 10.0356 9.19198 9.59456C9.63298 9.14456 10.236 8.90156 10.866 8.90156C11.496 8.90156 12.099 9.14456 12.54 9.59456C12.99 10.0356 13.233 10.6386 13.233 11.2686C13.233 11.8986 12.99 12.5016 12.54 12.9426Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6160_13553">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3 3.40259)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
